import { watch } from 'vue'
import { useAuthStore } from '@/store/auth'
import { createUserActivity } from '@/service/user-activity.mjs'

// 화면 조작(누르기·키 입력·스크롤·화면 이동)과 학습을 활동으로 기록하고, 1시간 동안 활동이 없으면 로그아웃한다.
// 서버도 같은 기준으로 세션을 끝내므로 브라우저를 닫아 둔 경우에도 다시 들어오면 로그인부터 한다.
export default defineNuxtPlugin(nuxtApp => {
  const auth = useAuthStore(), router = nuxtApp.$router
  const activity = createUserActivity({
    storage: window.localStorage,
    isLoggedIn: () => auth.isLoggedIn,
    ping: () => auth.client.request('/api/user/auth/activity', { method: 'POST' }),
    async onIdle() {
      auth.endingSession = true
      try { await auth.client.logout() } catch { /* 서버도 유휴 만료로 세션을 끝낸다. 화면은 로그아웃 상태로 둔다. */ }
      try { await router.replace({ path: '/login', query: { notice: 'idle', returnTo: router.currentRoute.value.fullPath } }) }
      finally { auth.endingSession = false }
    },
  })
  let throttle = 0
  const input = () => { const time = Date.now(); if (time - throttle < 1000) return; throttle = time; activity.mark() }
  for (const type of ['pointerdown', 'keydown', 'wheel', 'touchstart']) window.addEventListener(type, input, { passive: true, capture: true })
  router.afterEach(() => activity.mark())
  // 로그인·세션 복원 직후는 활동으로 본다(서버가 유휴 만료 전 세션만 복원한다).
  watch(() => auth.member, (value, previous) => { if (value && !previous) activity.mark({ remote: false }) })
  window.setInterval(() => { activity.check() }, 30000)
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') activity.check() })
  return { provide: { userActivity: activity } }
})
